import React from 'react';
import SvgIcon from '../../images/ilustrations/Anye_Grillete_new.svg';

const AnyeGrillete = () => (
    <img src={SvgIcon} alt="Grillete" style={{ width: '1.5em', height: '1.5em' }} />
);

export default AnyeGrillete;
